import React, { useMemo } from 'react'
import { Box } from '@material-ui/core'
import { useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/styles'
import { useAuthAccount } from '~/store/auth/useAuthAccount'
import { DocumentationStatusDescription } from './components'
import { DocumentationOnboardContainer } from '../../components'
import { RedirectPJAnalysisStep, StatusBadge } from '~/components'
import { AccountAnalysisStatus } from '@mutual-services/account-types'
import {
  hasDeniedAccountStatus,
  hasAnalysisAccountStatus,
  hasApprovedAccountStatus,
  getAnalysisFeedbackPageTitle,
  getAnalysisFeedbackPageBadgeType,
  hasRequiredNewCustomerAccountStatus
} from '~/utils/analysisStatus'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})

export const DocumentationStatus = () => {
  const { pjAnalysisStatus, createdAt } = useAuthAccount()
  const { status, updatedAt } = pjAnalysisStatus
  const classes = useStyles()
  const location = useLocation<{ shouldSkipRedirect: boolean }>()
  const { state } = location
  const shouldSkipRedirect = state && state.shouldSkipRedirect

  const title = useMemo(() => getAnalysisFeedbackPageTitle(status), [status, getAnalysisFeedbackPageTitle])
  const badgeType = useMemo(() => getAnalysisFeedbackPageBadgeType(status), [status, getAnalysisFeedbackPageBadgeType])

  const shouldRedirect = useMemo(() => !(
    hasDeniedAccountStatus(status) ||
    hasApprovedAccountStatus(status) ||
    hasAnalysisAccountStatus(status) ||
    hasRequiredNewCustomerAccountStatus(status)
  ), [status])

  if (shouldRedirect && !shouldSkipRedirect) {
    return (
      <RedirectPJAnalysisStep
        status={status}
      />
    )
  }

  return (
    <DocumentationOnboardContainer
      title={title}
      description={<DocumentationStatusDescription status={status} />}
    >
      <Box className={classes.container}>
        <StatusBadge
          status={status}
          type={badgeType}
          analysisDate={updatedAt}
          solicitationDate={createdAt}
          termTime={status === AccountAnalysisStatus.ANALYST_QUEUE ? 1 : 2}
        />
      </Box>
    </DocumentationOnboardContainer>
  )
}
